import { Button } from './ui/button';
import { useState } from 'react';
import { supabase } from '@/services';
import { Spinner } from './ui/spinner';
import { useToast } from '@/hooks/use-toast';
import { Send } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type SmsBtnProps = {
  phoneNumber: string;
  firstName: string;
  lastName: string;
};

const SmsBtn = ({ phoneNumber, firstName, lastName }: SmsBtnProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();
  const sendSms = async () => {
    setIsLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke('sms', {
        body: JSON.stringify({
          phoneNumber,
          body: `Your installer will arrive shortly. Please ensure you are available to let them in.`,
          firstName,
          lastName,
        }),
      });
      if (error) {
        toast({
          title: 'Error',
          description: 'Message not sent',
          variant: 'destructive',
        });
        console.log('error', error);
        return;
      } else {
        toast({
          title: 'Success',
          description: 'Message sent',
          variant: 'default',
        });
      }
      console.log(data);
    } finally {
      setIsLoading(false);
    }
  };
  const { t } = useTranslation();

  return (
    <Button className="inline-flex gap-2" onClick={sendSms} disabled={isLoading}>
      <span className="">
        {isLoading ? (
          <div className="flex gap-2 justify-center items-center">
            <Spinner /> <p>{t('sending')}.</p>
          </div>
        ) : (
          t('notify')
        )}
      </span>
      <Send size={14} />
    </Button>
  );
};

export default SmsBtn;
